import Avatar from "./Avatar";
import Button from "./Button";
import Icon from "./icons/Icon";
import SongLoesung from "./SongLoesung";
import { AUFGABEN } from "../aufgaben";
import "./DuBistDran.css";

/**
 * Wer gebuzzert hat, bekommt den ganzen Bildschirm: erst "Du bist dran"
 * mit der Aufgabe, dann die Loesung und "Lagst du richtig?".
 * Bewerten geht ERST nach dem Aufdecken — vorher lagen Richtig/Falsch
 * direkt unter dem Buzzer, ein Daumen zu tief und die Runde war entschieden.
 * Gilt fuer Mitspieler und den mitspielenden Host.
 * @category spiel
 */
export function DuBistDran({ name, farbe, taskType, loesung, onAufdecken, onRichtig, onFalsch }) {
  const aufgabe = AUFGABEN[taskType];
  return (
    <div className="dran-ebene" role="dialog" aria-modal="true" aria-label="Du bist dran">
      <div className="spiel stimmung-gruen">
        {!loesung ? (
          <>
            <main className="spiel-mitte">
              <div className="ansage">
                <Avatar name={name} farbe={farbe} groesse="riesig" puls />
                <h1>Du bist dran!</h1>
                <p>Sag deine Antwort laut. Gesucht wird:</p>
                <span className="chip">
                  <Icon name={aufgabe?.icon || "titel"} />
                  {aufgabe?.name || "…"}
                </span>
              </div>
            </main>
            <div className="daumenzone">
              <Button variant="hell" onClick={onAufdecken}>
                <Icon name="auge" />
                Lösung aufdecken
              </Button>
              <p className="hinweis-text">Erst antworten, dann aufdecken.</p>
            </div>
          </>
        ) : (
          <>
            <main className="spiel-mitte">
              <span className="ueberzeile gruen">Die Lösung</span>
              <SongLoesung songData={loesung} gross />
            </main>
            <div className="daumenzone">
              <h2 className="dran-frage">Lagst du richtig?</h2>
              <div className="reihe">
                <Button variant="neben" className="falsch hoch" onClick={onFalsch}>
                  <Icon name="x" />
                  Falsch
                </Button>
                <Button variant="haupt" className="hoch" onClick={onRichtig}>
                  <Icon name="check" />
                  Richtig
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default DuBistDran;
